<template>
  <v-dialog v-model="showDelete" persistent max-width="350">
    <v-card>
      <v-card-title>Delete</v-card-title>
      <v-divider/>
      <v-card-text class="pt-4">
        Are you sure you want to delete {{name}}?
        <div class="mt-4 font-weight-bold text-subtitle-1">
          <v-icon color="warning" large>mdi-alert</v-icon>
          This action cannot be undone.</div>
      </v-card-text>
      <v-divider/>
      <v-card-actions class="pr-6">
        <v-spacer></v-spacer>
        <v-btn color="error" plain @click="deleteObject">Delete</v-btn>
        <v-btn color="primary" @click="cancel">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

export default {
  name: 'DeleteObject',
	props: {
    value: {type:Boolean,required:true},    // Show dialog
    name: {type:String, required:false,default:'this item'}
  },
  data() {
    return {
      showDelete: false,
    }
  },
  watch: {
    value() {
      this.showDelete = this.value;
    }
  },
  methods: {
    cancel() {
      this.showDelete = false;
      this.$emit('input', false);
    },
    deleteObject() {
      this.showDelete = false;
      this.$emit('delete')
      this.$emit('input', false);
    }
  }
}
</script>